export default __webpack_public_path__ + "static/media/airofdeath.b125a711.png";